import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
  container: {
    display: 'flex',
    minWidth: '400px',
    padding: '24px 32px',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '24px',
    // borderRadius: '0 12px 12px 12px',
    // border: '1px solid  #EAECF0',
    background: '#fff',
    boxShadow: '0 1px 2px 0 rgba(16, 24, 40, 0.05)',
    maxWidth: '1315px',
    [theme.breakpoints.up('xl')]: {
      maxWidth: '1451px',
    },
    [theme.breakpoints.down('1024')]: {
      maxWidth: '800px',
    },
    [theme.breakpoints.down('1440')]: {
      maxWidth: '1017px',
    },
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  title: {
    color: theme.palette.text.primary,
    fontSize: '18px',
    fontWeight: 600,
    lineHeight: '28px',
  },
  textBtn: {
    color: theme.palette.text.tertiary,
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '20px',
  },
  cardsWrapper: {
    display: 'grid',
    gridAutoFlow: 'column',
    gridAutoColumns: 'calc(100% - 10px)',
    gridTemplateRows: 'repeat(2, auto)',
    gap: '20px',
    overflowX: 'auto',
    overflowY: 'hidden',
    paddingBottom: '1rem',
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    width: '100%',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },

  card: {
    borderRadius: '16px',
    border: '1px solid #EAECF0',
    background: theme.palette.background.hover,
    display: 'flex',
    alignItems: 'center',
    padding: '16px',
  },
  cardHeader: {
    display: 'flex',
    padding: '20px 32px',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: '4px',
    flex: '1 0 0',
    alignSelf: 'stretch',
    width: '50%',
  },
  cardBody: {
    display: 'flex',
    padding: '20px',
    alignItems: 'flex-start',
    gap: '24px',
    flex: '1 0 0',
    width: '50%',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      padding: '32px',
      gap: '16px',
    },
  },
  installmentDetail: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '16px',
    flex: '1 0 0',
    [theme.breakpoints.down('xs')]: {
      gap: '16px',
      width: '100%',
    },
  },
  planItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  cardTitle: {
    color: theme.palette.text.primary,
    textAlign: 'center',
    fontFamily: 'Inter',
    fontSize: '24px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '32px',
  },
  actionBtnContainer: {
    display: 'flex',
    gap: '4px',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      justifyContent: 'flex-start',
    },
  },
  installmentText: {
    color: theme.palette.text.tertiary,
    fontFamily: 'Inter',
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px',
    [theme.breakpoints.down('xs')]: {
      fontSize: '14px',
      lineHeight: '20px',
    },
  },
  scrollArrows: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '12px',
    marginTop: theme.spacing(1),
    alignSelf: 'flex-end',
  },
  IconButton: {
    color: theme.palette.foreground.secondary,
    backgroundColor: theme.palette.alpha.alphaWhite90,
    '&:hover': {
      backgroundColor: theme.palette.background.hover,
    },
  },
}));
